import { View, StyleSheet, Font } from "@react-pdf/renderer";
import regular from "@packages/assets/font-family/Montserrat-Regular.ttf";
import bold from "@packages/assets/font-family/Montserrat-Bold.ttf";
import { EssentialQuestionsCardProps } from "./EssentialQuestionsCard";
import { PdfLayout } from "../pdf/PdfLayout";
import MarkdownRenderer from "../custom-markdown";
import { useTranslation } from "react-i18next";
import { scaleFontSize } from "../pdf/fontSizeAdjustment";

Font.register({
  family: "Montserrat",
  fonts: [{ src: regular }, { src: bold, fontWeight: "bold" }],
});

const styles = StyleSheet.create({
  questionContainer: {
    marginBottom: 15,
    padding: 12,
    backgroundColor: "#f0fdf4",
    borderRadius: 8,
  },
  questionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#16a34a",
  },
  prompt: {
    fontSize: 10,
    color: "#374151",
    lineHeight: 1.4,
  },
  responseItem: {
    flexDirection: "row",
    marginBottom: 4,
    paddingLeft: 8,
  },
  bullet: {
    width: 10,
    fontSize: 9,
    color: "#16a34a",
  },
});

const EssentialQuestionsDocument = ({
  questions,
  activitySuggestions,
  imageUrl,
  courseName,
  gradeLevel,
  topic,
  author,
  createdAt,
  customizationSettings,
}: Partial<EssentialQuestionsCardProps>) => {
  const { t } = useTranslation();
  return (
    <PdfLayout
      courseName={courseName}
      gradeLevel={gradeLevel}
      topic={topic}
      imageUrl={imageUrl}
      headerTextColor="#475569"
      author={author}
      createdDate={createdAt}
      customizationSettings={customizationSettings}
    >
      <View style={styles.questionContainer}>
        <MarkdownRenderer
          content={t("essentialQuestions.title")}
          customStyle={{
            text: {
              text: {
                ...styles.questionTitle,
                fontSize: scaleFontSize(
                  styles.questionTitle.fontSize,
                  customizationSettings?.fontSize,
                ),
              },
              container: {
                marginBottom: 8,
              },
            },
          }}
        />
        <MarkdownRenderer
          content={questions?.join("\n") ?? ""}
          customStyle={{
            text: {
              text: {
                ...styles.prompt,
                fontSize: scaleFontSize(
                  styles.prompt.fontSize,
                  customizationSettings?.fontSize,
                ),
              },
              container: {
                marginBottom: 8,
              },
            },
          }}
        />
      </View>
      {activitySuggestions?.map((activity, index) => (
        <View wrap={false} key={index} style={styles.questionContainer}>
          <MarkdownRenderer
            content={activity.title ?? ""}
            customStyle={{
              text: {
                text: {
                  ...styles.questionTitle,
                  fontSize: scaleFontSize(
                    styles.questionTitle.fontSize,
                    customizationSettings?.fontSize,
                  ),
                },
                container: {
                  marginBottom: 8,
                },
              },
            }}
          />
          <MarkdownRenderer
            content={activity.description ?? ""}
            customStyle={{
              text: {
                text: {
                  ...styles.prompt,
                  fontSize: scaleFontSize(
                    styles.prompt.fontSize,
                    customizationSettings?.fontSize,
                  ),
                },
                container: {
                  marginBottom: 8,
                },
              },
            }}
          />
        </View>
      ))}
    </PdfLayout>
  );
};

function EssentialQuestionsCardPDF(
  props: Partial<EssentialQuestionsCardProps>,
) {
  return <EssentialQuestionsDocument {...props} />;
}

export default EssentialQuestionsCardPDF;
